import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography, IconButton } from "@mui/material";
import { useState } from "react";
import { useUpdateCustomerTwilioConfigAPI } from "../../../../features/fans/settings/settings.api";
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "sonner";

type Props = {
  onClose: () => void;
  identityId: string;
  currentAdditionalMessages: number;
};

export default function AddSMSMessagesDialog({ onClose, identityId, currentAdditionalMessages }: Props) {
  const [additionalMessages, setAdditionalMessages] = useState<string>(currentAdditionalMessages.toString());
  const { mutate: updateMessages, isLoading } = useUpdateCustomerTwilioConfigAPI();

  const handleSubmit = () => {
    const numMessages = parseInt(additionalMessages, 10);
    if (!isNaN(numMessages)) {
      updateMessages({
        identityId,
        additionalMessages: numMessages
      }, {
        onSuccess: () => {
          toast.success("SMS messages updated successfully");
          onClose();
        },
        onError: () => {
          toast.error("Failed to update SMS messages");
        }
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setAdditionalMessages(value);
    }
  };

  return (
    <Dialog open={true} maxWidth="sm" onClose={onClose}>
      <DialogTitle sx={styles.dialogTitle}>
        <Box sx={styles.dialogHeader}>
          Edit Additional SMS Messages
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Box sx={styles.contentBox}>
          <Typography variant="body1" sx={styles.labelText} gutterBottom>
            Set the total number of additional messages for this user:
          </Typography>
          <TextField
            fullWidth
            label="Additional Messages"
            value={additionalMessages}
            onChange={handleChange}
            type="text"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button onClick={onClose} disabled={isLoading}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={isLoading}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  dialogTitle: {
    pb: 1
  },
  dialogHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  contentBox: {
    mt: 1,
    mb: 0
  },
  labelText: {
    mb: 2
  },
  dialogContent: {
    pt: 1,
    pb: 1
  },
  dialogActions: {
    pt: 1
  }
};